import React from 'react';
import Logo from '../header/logo';
import MobileLogo from '../header/MobileLogo';
import FacebookIcon from '../header/submenu/FacebookIcon';
import TwitterIcon from '../header/submenu/TwitterIcon';
import YouTubeIcon from '../header/submenu/YouTubeIcon';
import InstagramIcon from '../header/submenu/InstagramIcon';
import LinkedInIcon from '../header/submenu/LinkedInIcon';
import FooterCSS from './Footer.module.css';
import { NavLink } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <div className={FooterCSS.mainFooterWrapper}>
        <div className={FooterCSS.footerContentWrapper}>
          <div className={FooterCSS.footerLogo}>
            <Logo />
            <MobileLogo />
          </div>
          <div className={FooterCSS.footerUsefulLinksWrapper}>
            <h3>Quick Links</h3>
            <NavLink to='/swapandtop/' className={FooterCSS.footerUsefulLink}>
              Homepage
            </NavLink>
            <NavLink
              to='/swapandtop/tou'
              className={FooterCSS.footerUsefulLink}>
              Terms of use
            </NavLink>
            <NavLink
              to='/swapandtop/privacypolicy'
              className={FooterCSS.footerUsefulLink}>
              Privacy policy
            </NavLink>
            <NavLink
              to='/swapandtop/tipsandrecomandations'
              className={FooterCSS.footerUsefulLink}>
              Tips & recomendations
            </NavLink>
          </div>
          <div className={FooterCSS.footerContactUs}>
            <h3>Contact Us</h3>
            <div className={FooterCSS.footerDetails}>
              <p className={FooterCSS.footerDetailHeading}>Phone:</p>
              <p> +263774689010</p>
            </div>
            <div className={FooterCSS.footerDetails}>
              <p className={FooterCSS.footerDetailHeading}>Email:</p>
              <p>mail@swapandtop.co.zw</p>
            </div>
            <div className={FooterCSS.footerDetails}>
              <p className={FooterCSS.footerDetailHeading}>Adress:</p>
              <div className={FooterCSS.footerAddress}>
                <p>4442 Ceres Ave, Waterfalls, Harare </p>
              </div>
            </div>
            <div className={FooterCSS.socialMediaWrapper}>
              <div className={FooterCSS.footerMobileSocialWraper}>
                <div className='ham-socials-icons-wrap'>
                  <a href='https://www.facebook.com' target='_blank'>
                    <FacebookIcon socialIconClass={'ham-social-icon '} />
                  </a>
                  <a href='https://www.twitter.com' target='_blank'>
                    <TwitterIcon socialIconClass={'ham-social-icon'} />
                  </a>
                  <a href='https://www.youtube.com' target='_blank'>
                    <YouTubeIcon socialIconClass={'ham-social-icon'} />
                  </a>
                  <a href='https://www.instagram.com' target='_blank'>
                    <InstagramIcon socialIconClass={'ham-social-icon'} />
                  </a>
                  <a href='https://www.linkedin.com' target='_blank'>
                    <LinkedInIcon socialIconClass={'ham-social-icon'} />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={FooterCSS.footerInfo}>
        <p>{`© ${currentYear}`}</p>
        <a href='#' className={FooterCSS.gretaWorksLink}>
          Greta Works Inc.
        </a>
        <p>| All rights reserved</p>
      </div>
    </footer>
  );
}
